import React from "react";
import { Link } from "react-router-dom";
import CarCard from "../components/CarCard";
import Banner from "../components/BannerCarousel";
import MetaTags from "../components/MetaTags";
import { cars } from "../data/cars";

const Home = () => {
  const availableCars = cars.filter(car => !car.sold);
  const featuredCars = availableCars.slice(0, 3);

  return (
    <div>
      <MetaTags 
        title="MRautomotores - Autos Usados en Córdoba Argentina"
        description="Encontrá tu auto ideal en Argentina al mejor precio. Autos usados verificados con garantía, financiación y entrega inmediata. Renault, Fiat, Ford, Chevrolet y más."
        url="https://mrautomotores.com"
      />
      
      {/* Banner */}
      <Banner />

      {/* Featured Cars */}
      <section className="py-4 md:py-8 bg-slate-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 md:mb-8 text-slate-800">
            Vehículos Destacados
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {featuredCars.map((car) => (
              <CarCard key={car.id} car={car} />
            ))}
          </div>
          <div className="text-center mt-4 md:mt-8">
            <Link
              to="/catalogo"
              className="bg-sky-600 hover:bg-sky-700 text-white font-bold py-2 px-6 rounded transition-colors duration-200"
              onClick={() => window.scrollTo(0, 0)}
            >
              Ver Todos los Vehículos
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-8 md:py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-12 text-gray-800">
            ¿Por qué elegir MRautomotores?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
            <div className="text-center">
              <div className="bg-sky-100 rounded-full p-6 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-sky-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                Autos usados verificados en Córdoba
              </h3>
              <p className="text-gray-600">
                Todos nuestros autos usados en Córdoba pasan por controles
                mecánicos rigurosos, garantizando seguridad, rendimiento y
                confianza al momento de comprar.
              </p>
            </div>
            <div className="text-center">
              <div className="bg-sky-100 rounded-full p-6 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-sky-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                Mejores precios en autos usados en Córdoba
              </h3>
              <p className="text-gray-600">
                Ofrecemos autos usados en Córdoba al mejor precio del mercado,
                con opciones accesibles y oportunidades únicas en vehículos
                seleccionados.
              </p>
            </div>
            <div className="text-center">
              <div className="bg-sky-100 rounded-full p-6 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-sky-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                Financiación y asesoramiento personalizado
              </h3>
              <p className="text-gray-600">
                Te ayudamos a comprar tu auto usado en Córdoba con financiación,
                atención personalizada y acompañamiento durante todo el proceso.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
